<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>시스템 관리</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">시스템 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">사용자관리</p>
          <ul class="depth">
            <li><router-link to="/usermanagement" title="사용자관리">사용자관리</router-link></li>
            <li><router-link to="/teamlist" title="팀관리">팀관리</router-link></li>
            <li><router-link to="/departmentlist" title="부서관리">부서관리</router-link></li>
            <li><router-link to="/menulist" title="메뉴관리">메뉴관리</router-link></li>
            <li><router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link></li>
            <li><router-link to="/accessinfo" title="접속정보">접속정보</router-link></li>
            <!-- <li><router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">사용자 조회</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                사용자 조회 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 80px" />
                <col style="width: 35%" />
                <col style="width: 15%; min-width: 80px" />
                <col style="width: 35%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">사용자 아이디</th>
                  <td colspan="3">{{ employeeInfo.empNo }}</td>
                </tr>
                <tr>
                  <th scope="row">이름</th>
                  <td>{{ employeeInfo.empNm }}</td>
                  <th scope="row">사용자 상태</th>
                  <td>{{ employeeInfo.empSttus }}</td>
                </tr>
                <tr>
                  <th scope="row">부서명</th>
                  <td>{{ employeeInfo.empDeptNm }}</td>
                  <th scope="row">팀명</th>
                  <td>{{ employeeInfo.empTeamNm }}</td>
                </tr>
                <!-- <tr>
                  <th scope="row">업무구분</th>
                  <td colspan="3">{{ employeeInfo.empDutyNm }}</td>
                </tr>
                <tr>
                  <th scope="row">근무지역</th>
                  <td colspan="3">{{ employeeInfo.workSectnId }}</td>
                </tr> -->
                <tr>
                  <th scope="row">휴대폰번호</th>
                  <td>{{ employeeInfo.empMobile }}</td>
                  <th scope="row">전화번호</th>
                  <td>{{ employeeInfo.empTelNo }}</td>
                </tr>
                <tr>
                  <th scope="row">이메일주소</th>
                  <td colspan="3">{{ employeeInfo.empEmail }}</td>
                </tr>
                <tr>
                  <th scope="row">사용자 권한</th>
                  <td colspan="3">{{ employeeInfo.authorNm }}</td>
                </tr>
                <!-- <tr>
                  <th scope="row">단말기 아이디</th>
                  <td colspan="3"></td>
                </tr>
                <tr>
                  <th scope="row">단말기 전화번호</th>
                  <td colspan="3"></td>
                </tr> -->
              </tbody>
            </table>
          </div>
          <!--table-->
        </article>
        <article class="btnArea">
          <button class="btn border" @click="$router.push('usermanagement')">목록</button>
          <button class="btn blue" @click="updateBtn">수정</button>
        </article>
      </div>
    </section>

    <!-- 알럿 -->
    <alert v-show="showModalMsgSuccess">
      <template #content>
        <p>{{ msg1 }}</p>
        <p>{{ msg2 }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="CloseBtn">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert>
  </main>
</template>

<script>
import Alert from '../../../components/Alert01.vue';
import axios from '../../../util/axios';

export default {
  data() {
    return {
      showModalMsgSuccess: false,
      msg1: '해당 사용자를 삭제하시겠습니까?',
      msg2: '해당 사용자의 정보가 모두 삭제 됩니다.',
      msg3: '정보를 변경 하시겠습니까?',

      empEsntlId: this.$route.query.id,
      employeeInfo: {},
      dataInfo: {},
    };
  },

  components: {
    Alert,
  }, 

  created() {
    const empId = this.$route.query.id;
    if (!empId) {
      alert('잘못된 접근입니다.');
      this.$router.push('usermanagement');
      return;
    }
    this.empId = empId;
  },

  mounted() {
    this.findMember();
  },

  methods: {
    CancleBtn() {
      this.showModalMsgSuccess = false;
    },

    CloseBtn() {
      this.showModalMsgSuccess = false;
    },

    async findMember() {
      const res = await axios('get', '/api/member/view.json', {
        empEsntlId: this.empEsntlId,
      });
      const data = res.data;
      this.employeeInfo = data.resultVo;
      if (this.employeeInfo.empSttus == 'A') {
        this.employeeInfo.empSttus = '신청';
      } else if (this.employeeInfo.empSttus == 'D') {
        this.employeeInfo.empSttus = '삭제';
      } else {
        this.employeeInfo.empSttus = '승인';
      }
    },

    updateBtn() {
      const params = {
        empNo: this.employeeInfo.empNo,
        empNm: this.employeeInfo.empNm,
        empDeptCd: this.employeeInfo.empDeptCd,
        empTeamCd: this.employeeInfo.empTeamCd,
        empAuthCd: this.employeeInfo.authCode,
        empMobile: this.employeeInfo.empMobile,
        empTelNo: this.employeeInfo.empTelNo,
        empEmail: this.employeeInfo.empEmail,
        empEsntlId: this.empEsntlId,
      };

      this.$router.push({
        name: 'userupdate',
        params: { data: params },
      });
    },
  },
};
</script>
